const FEATURES = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '全网吃瓜内容实时同步，51吃瓜官网最新入口第一时间呈现，绝不错过任何热点。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '独家爆料',
    desc: '汇聚51吃瓜网独家深度爆料，从娱乐圈内幕到社会事件全景追踪，料足瓜甜。',
  },
  {
    icon: 'ri-stack-line',
    title: '多源聚合',
    desc: '吃瓜网站线路一整合全网多平台信息源，一个51吃瓜入口看遍所有精彩内容。',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: '智能推荐',
    desc: '根据您的浏览偏好，精准推送最合口味的吃瓜内容，省时又过瘾。',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '隐私安全',
    desc: '51吃瓜网址浏览全程匿名保护，不追踪、不记录，放心吃瓜无后顾之忧。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            为什么选择吃瓜网站线路一
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            作为51吃瓜官网全网最新入口，我们致力于为您提供最优质的吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {FEATURES.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl p-6 transition-all duration-300 hover:bg-background-50 hover:-translate-y-1 cursor-default"
            >
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors">
                <i className={`${item.icon} text-xl text-primary-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2 font-heading">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}